import { http } from "services/http";

import type { BadgesResponse } from "models/app.model";

// App wide data, owned by no page: the sidenav counters and the server clock.
export const appApi = {
  getBadges: () => http.quiet().post<BadgesResponse>("/api/badges"),
};
